import type { FunctionComponent } from 'react';
import { OpenModalButton, StyledListingImageComponent } from '../../MediaShowcaseBrick.styled';
import {
  isAerialImage,
  MediaShowcaseV2AerialItem,
  MediaShowcaseV2ListingItem,
} from '../../../../../app-kit/components/Image/types';
import { AerialShowcaseImage } from '../AerialShowcaseImage/AerialShowcaseImage';
import { useMediaGalleryModalContext } from '../../../../contexts/MediaGalleryModalContext/MediaGalleryModalContext';
import { mediaGalleryModalId } from '../../../MediaGalleryModal/MediaGalleryModal';

interface ShowcaseItem {
  item: MediaShowcaseV2ListingItem | MediaShowcaseV2AerialItem;
}

export const ShowcaseItem: FunctionComponent<ShowcaseItem> = ({ item: { image, key } }) => {
  const { showModal } = useMediaGalleryModalContext();

  return (
    <OpenModalButton
      onClick={() => {
        showModal({
          openAction: 'MediaShowcaseBrick:Click',
          galleryItemKey: key,
        });
      }}
      aria-label="Open Media Gallery Modal"
      aria-controls={mediaGalleryModalId}
    >
      {isAerialImage(image) ? (
        <AerialShowcaseImage href={image.uri} alt={image.alt} />
      ) : (
        <>
          <StyledListingImageComponent
            dangerouslySetClassnames={{
              img: 'property-page-media-showcase-image',
            }}
            mediaItem={{
              desktopFullScreenImageJpgUri: image.desktopFullScreenImageJpgUri,
              mobileFullScreenImageJpgUri: image.mobileFullScreenImageJpgUri,
              desktopFullScreenImageWebpUri: image.desktopFullScreenImageWebpUri,
              mobileFullScreenImageWebpUri: image.mobileFullScreenImageWebpUri,
              alt: image.alt,
            }}
            loading="eager"
          />
        </>
      )}
    </OpenModalButton>
  );
};
